import { Skeleton } from 'src/components/ui/skeleton';
import { cn } from 'src/lib/utils';

export default function LoadingState({ rows = 6, className }) {
  return (
    <div className={cn('space-y-3', className)}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} className="h-12 w-full" />
      ))}
    </div>
  );
}
